/** A re-rendering clock for countdown displays (monotonic milliseconds). */
import { useEffect, useState } from 'react';

const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

/** The current monotonic time, refreshed every `intervalMs` while `active`. */
export function useNow(intervalMs = 250, active = true): number {
  const [t, setT] = useState(now);
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => {
      setT(now());
    }, intervalMs);
    return () => {
      clearInterval(id);
    };
  }, [intervalMs, active]);
  return t;
}
